import { setJsonToStorage } from '@hcr/utils'

import { MOCKS_CONFIG } from '../configs'
import type { MocksSettings } from '../models'

export const saveMocksSettings = (settings: MocksSettings): void =>
  setJsonToStorage(MOCKS_CONFIG.storageKeyName, settings)
